@if (form) {
  <nimbus-form-wrapper [formGroup]="form">
    <div class="settings-row">
      <nimbus-form-row>
        <nimbus-form-control>
          <nimbus-input-autocomplete
            defaultSearch
            [label]="TranslationKeys.AssistantSettingsLanguage | translate"
            [options]="languages"
            [required]="true"
            id="language"
            formControlName="language"
            panelClass="assistant-settings-dropdown"
          >
          </nimbus-input-autocomplete>
        </nimbus-form-control>
      </nimbus-form-row>
      <nimbus-form-row>
        <nimbus-form-control>
          <nimbus-input-slide-toggle id="autorun" formControlName="autorun" [label]="TranslationKeys.AssistantSettingsAutorun | translate">
          </nimbus-input-slide-toggle>
        </nimbus-form-control>
      </nimbus-form-row>
      <nimbus-form-row>
        <nimbus-form-control>
          <nimbus-input-slide-toggle
            id="onTopTeamToast"
            formControlName="onTopTeamToast"
            [label]="TranslationKeys.SettingsShowPreCallInfo | translate"
          >
          </nimbus-input-slide-toggle>
        </nimbus-form-control>
      </nimbus-form-row>
      @if (preCallInfoEnabled && form.value?.onTopTeamToast) {
        <nimbus-form-row>
          <nimbus-form-control>
            <nimbus-input-autocomplete
              defaultSearch
              [label]="TranslationKeys.SettingsPreCallInfo | translate"
              [options]="preCallInfoTabs"
              [required]="form.value?.onTopTeamToast"
              id="preCallInfo"
              formControlName="preCallInfo"
              panelClass="assistant-settings-dropdown"
            >
            </nimbus-input-autocomplete>
          </nimbus-form-control>
        </nimbus-form-row>
      }
      <nimbus-form-row>
        <nimbus-form-control>
          <nimbus-input-slide-toggle
            id="openLoginWindowOnStartup"
            formControlName="openLoginWindowOnStartup"
            [label]="TranslationKeys.SettingsOpenLoginWindowOnStartup | translate"
          >
          </nimbus-input-slide-toggle>
        </nimbus-form-control>
      </nimbus-form-row>
    </div>
  </nimbus-form-wrapper>
}
